// Libs
import { createContext } from "react";

// Utils
import { type DomainType, useBuildDomains } from "./domains.config";

export const DomainContext = createContext<DomainType | undefined>(undefined);

interface DomainProviderProps {
    children: React.ReactNode | string;
}

export function DomainProvider({ children }: DomainProviderProps): JSX.Element {
    const domains = useBuildDomains();

    return <DomainContext.Provider value={domains}>{children}</DomainContext.Provider>;
}
